import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { IDeltaHistorySyncs, ISync } from "./../models";
import { WorkdayUserProvisioningService } from "../workday-user-provisioning-service";
import dayjs from "@gtmhub/dayjs";
import { WorkdayOperationsReportService } from "../workday-operations-report-service";

export class SyncHistoryCtrl {
  indicators: {
    loading: boolean;
  };

  isAdmin: boolean;
  syncs: ISync[];

  static $inject = ["WorkdayUserProvisioningService", "UIErrorHandlingService", "WorkdayOperationsReportService"];

  constructor(
    private workdayUserProvisioningService: WorkdayUserProvisioningService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private workdayOperationsReportService: WorkdayOperationsReportService
  ) {}

  $onInit(): void {
    this.indicators = {
      loading: false,
    };
    this.getDeltaHistorySyncs();
  }

  getDeltaHistorySyncs = (): void => {
    this.indicators.loading = true;
    this.workdayUserProvisioningService
      .getDeltaHistorySyncs()
      .then((response) => {
        this.syncs = this.normalizeSyncData(response);
        this.indicators.loading = false;
      })
      .catch((error) => {
        this.indicators.loading = false;
        this.uiErrorHandlingService.handleModal(error);
      });
  };

  toggleItemVisibility = (item: ISync): void => {
    item.visible = !item.visible;
  };

  downloadReport = (sync: ISync): void => {
    this.workdayOperationsReportService.triggerDownload(sync);
  };

  private calcDateDiff = (date: Date): number => dayjs().diff(dayjs(date).format("YYYY-MM-DD"), "d");

  private normalizeSyncData = (syncs: IDeltaHistorySyncs) =>
    syncs.items
      .map((sync) => {
        const operationsSet = new Set();
        return <ISync>{
          dateDiff: this.calcDateDiff(sync.endTime),
          visible: false,
          ...sync,
          ...sync.operations.reduce(
            (acc, curr) => {
              operationsSet.add(curr.success);
              // temporary fix for inconsistent data received from backend:
              if (!curr.entityType || !curr.operationType) {
                return acc;
              }

              if (!curr.success) {
                return acc[curr.entityType].error++, acc;
              }

              const operationType = curr.operationType === "modify_assignments" ? "update" : curr.operationType;
              return acc[curr.entityType][operationType]++, acc;
            },
            {
              user: {
                create: 0,
                update: 0,
                delete: 0,
                error: 0,
              },
              team: {
                create: 0,
                update: 0,
                delete: 0,
                error: 0,
              },
            }
          ),
          successStatus: operationsSet.size === 2 ? "partialSuccess" : [...operationsSet][0] ? "success" : "failed",
        };
      })
      .sort((a, b) => dayjs(b.endTime).diff(dayjs(a.endTime), "ms"));
}
